export default function AdminAnalytics() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="w-16 h-16 bg-tayo-light rounded-2xl flex items-center justify-center mb-5">
        <svg className="w-8 h-8 text-tayo" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
        </svg>
      </div>
      <h3 className="text-lg font-bold text-charcoal mb-2">Umami 분석 대시보드</h3>
      <p className="text-sm text-sub-text mb-6">실시간 방문자, 이벤트, 세션 등을 확인할 수 있습니다</p>
      <a
        href="https://stats.vada.so/websites/9c8829ff-9c3a-4d8d-8766-22060ba624f9"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-press px-6 py-3 bg-gradient-to-r from-tayo to-tayo-dark text-white font-bold rounded-2xl hover:shadow-lg transition-shadow"
      >
        대시보드 열기
      </a>
    </div>
  );
}
